module.exports = __webpack_public_path__ + "img/shape-1.a3cb4828.png";